import React, { useState } from "react";
import LoginBanner from "../../assets/images/ornament.png";
import Logo from "../../components/layouts/logo";
import Inputs from "../../components/inputs/main";
import useAuthStore from "../../data/stores/authStore";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import useGenFetcher, { apiCall } from "../../data/useFetcher";
import useErrorStore from "../../data/stores/errorStore";
import { useNavigate } from "react-router-dom";
import { MainBtn } from "../../components/app/buttons";

interface FormType {
	email: string;
	password: string;
}

const Login = () => {
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm({
		defaultValues: {
			password: "",
			email: "",
		},
	});

	const { login } = useAuthStore(),
		{ loadUser } = useGenFetcher(),
		navigate = useNavigate();

	const [loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore();
	let onSubmit = async (data: FormType) => {
		setLoading(true);

		let { response, errArr, errMsg } = await apiCall({
			type: "post",
			url: `/api/v1/user/login`,
			data,
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			login(response);
			loadUser();
			navigate("/");
			return;
		}
		setLoading(false);
	};

	return (
		<div>
			<div className="w-full flex h-screen">
				<div className="w-[60%] flex h-full justify-center items-center relative">
					<div className="absolute top-10 left-20">
						<Logo type={"dark"} />
					</div>
					<div className="w-3/4 mx-auto h-full flex items-center justify-center">
						<div className="w-5/6">
							<h2 className="text-3xl font-semibold text-center inter text-da-blue-300">
								Sign In
							</h2>
							<p className="text-base font-normal mt-4 inter text-slate-500 text-center">
								Welcome back, you’ve been missed!
							</p>
							<form className="mt-6 px-5" onSubmit={handleSubmit(onSubmit)}>
								<div className="space-y-6">
									<div>
										<Controller
											name="email"
											control={control}
											rules={{
												required: "This field is required",
												pattern: {
													value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
													message: "Invalid email format",
												},
											}}
											render={({ field: { value, onChange, name } }) => (
												<Inputs
													type="email"
													value={value}
													onChange={onChange}
													placeholder="example@mail.com"
													icon="mage:email"
													label="Email"
													name={name}
												/>
											)}
										/>
										{errors.email && (
											<p className="text-[#dc2626] text-xs">
												{errors.email.message}
											</p>
										)}
									</div>
									<div>
										<Controller
											name="password"
											control={control}
											rules={{
												required: "This field is required",
												pattern: {
													value:
														/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/g,
													message:
														"Your password must have at least one uppercase letter, one lowercase letter, one digit, one special character, and a minimum length of 8 characters.",
												},
											}}
											render={({ field: { value, onChange, name } }) => (
												<Inputs
													type="password"
													value={value}
													onChange={onChange}
													name={name}
													icon="mdi:password-outline"
													label="Password"
													placeholder="**********"
												/>
											)}
										/>
										{errors.password && (
											<p className="text-[#dc2626] text-xs">
												{errors.password.message}
											</p>
										)}
									</div>
									<h6 className="text-sm font-normal text-da-blue-100 text-right inter">
										Forgot Password?
									</h6>
									{/* <button
										onClick={login}
										className="mt-3 bg-da-blue-100 w-full h-11 text-[#F8FAFC] rounded-xl inter font-medium text-sm">
										Sign in
									</button> */}
									<MainBtn
										loading={loading}
										text={"Sign In"}
										className="mt-3 bg-da-blue-100 w-full h-11 text-[#F8FAFC] rounded-xl inter font-medium text-sm"
									/>
								</div>
							</form>
						</div>
					</div>
				</div>
				<div className="w-[40%]">
					<img src={LoginBanner} alt="" className="w-full h-full" />
				</div>
			</div>
		</div>
	);
};

export default Login;
